module.exports = "<div style=\"width: 100%; height:100%;\">\n    <canvas baseChart\n            [datasets]=\"barChartData\"\n            [labels]=\"barChartLabels\"\n            [options]=\"barChartOptions\"\n            [legend]=\"barChartLegend\"\n            [chartType]=\"barChartType\"\n            (chartHover)=\"chartHovered($event)\"\n            (chartClick)=\"chartClicked($event)\">\n    </canvas>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeffrey/Documents/web development/ciphersite/src/app/letter-frequency/letter-frequency.component.html
// module id = ../../../../../src/app/letter-frequency/letter-frequency.component.html
// module chunks = main